import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { BaseService } from './base.service';
import { PaginationParams } from '../interfaces/user.interface';

export interface Payment {
  id: string;
  transactionId: string;
  amount: number;
  currency: string;
  status: 'completed' | 'pending' | 'failed' | 'cancelled' | 'processing';
  paymentType: string;
  date: string;
  appointmentId?: string;
  description?: string;
  patient?: {
    id: string;
    firstName: string;
    lastName: string;
    passportNumber?: string;
  };
  externalId?: string;
  checkoutLink?: string;
  reference?: string;
  externalPaymentId?: number | string;
  externalApiId?: string;
  createdAt?: string;
  updatedAt?: string;
  appointment?: {
    id: string;
    type?: string;
    title?: string;
    date?: string;
    doctor?: string;
    reason?: {
      id?: string;
      label?: string;
      _id?: string;
    };
    startTime?: string;
    endTime?: string;
    structure?: {
      id?: string;
      name?: string;
    };
  };
}

@Injectable({
  providedIn: 'root',
})
export class PaymentService extends BaseService {
  constructor(http: HttpClient) {
    super(http);
  }

  /**
   * Récupère l'historique des paiements
   */
  getPayments(params: PaginationParams = {}): Observable<any> {
    const httpParams = this.createParams(params);
    return this.http.get(`${this.baseUrl}/payments`, {
      headers: this.getHeaders(),
      params: httpParams,
    });
  }

  /**
   * Récupère les détails d'un paiement
   */
  getPaymentDetails(paymentId: string): Observable<any> {
    return this.http.get(`${this.baseUrl}/payments/${paymentId}`, {
      headers: this.getHeaders(),
    });
  }
}

